import {useState} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import doRequest from "../../requests/requests";
import './User.css'

function Login({showLogin, toggle, setUser}) {
    let uri = "https://sshm4damsapi.fly.dev"
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const navigate = useNavigate()
    const login = async () => {
        try {

            const resp = await doRequest({
                onProgress: undefined, contentType: 'application/json', uri: uri + "/login", method: 'POST', body: {
                    username: username,
                    password: password
                }, credentials: 'omit'
            })
            if (resp.ok)
                loginProcess(await resp.json());
            else {
                alert('Login Error')
                console.error(await resp.json())
            }
        } catch (err) {
            alert('Login Error')
            console.error(err)
        }


        function loginProcess(jsonResp) {
            const base64 = parseToken(jsonResp.token);
            const payload = JSON.parse(window.atob(base64));
            console.log('Auth', payload);
            setUser({username: payload.username, role: payload.role});
            alert('Logged in successfully!');
            closeLogin();
            navigate('/');
        }
    }
    const userHandleChange = (event) => {
        setUsername(event.target.value)
    }
    const passwordHandleChange = (event) => {
        setPassword(event.target.value)
    }
    const closeLogin = () => {
        toggle(false)
    }
    return (
        <Modal show={showLogin} onHide={closeLogin}>
            <ModalHeader closeButton
                         toggle={closeLogin}>
                Login
            </ModalHeader>
            <ModalBody className='login form'>
                <label>Username: </label>
                <input type="text"
                       id="username"
                       name="username"
                       placeholder="Enter a username"
                       value={username}
                       onChange={userHandleChange}
                       required/>

                <label>Password: </label>
                <input type="password"
                       id="password"
                       name="password"
                       placeholder="Enter a password"
                       value={password}
                       onChange={passwordHandleChange}
                       required/>

                <Button variant="primary" id='login-btn' onClick={login}>Login</Button>
            </ModalBody>
            <ModalFooter>
                <Button variant="primary"
                        onClick={closeLogin}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>

    )
}

export default Login

function parseToken(token) {
    sessionStorage.setItem('jwt', token);
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return base64
}
